import type {Iso8601DateTime, Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {z as zod} from "zod";
import {iso8601DateTimeZodValidator, uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";

// TODO: Please think of a better name for this type.
export type AdminUserDetail = {
    id: Uuid;
    userId: Uuid;
    name: string | null;
    email: string | null;
    phoneNumber: string | null;
    createdAt: Iso8601DateTime;
    updatedAt: Iso8601DateTime;
};

export const adminUserDetailValidator = zod.object({
    id: uuidZodValidator,
    userId: uuidZodValidator,
    name: zod.string().nullable(),
    email: zod.string().nullable(),
    phoneNumber: zod.string().nullable(),
    createdAt: iso8601DateTimeZodValidator,
    updatedAt: iso8601DateTimeZodValidator,
});
